import { QarzanTypesApi } from "types/qarzanHassana";
import axiosInstance from "./axiosInstance";
import { getAuthHeader } from "./qarzanHassanaService";

export interface QardanPolicyFilters {
  policyName?: string;
  employeeTypePublicId?: string;
  employmentStatusPublicId?: string;
  gradePublicId?: string;
  isActive?: boolean;
  pageNo?: number;
  pageSize?: number;
}

export interface QardanPolicyListItem {
  publicId: string;
  policyName: string;
  qarzanTypePublicId: string;
  employeeTypePublicId: string | null;
  employmentStatusPublicId: string | null;
  gradePublicId: string | null;
  createdAt: string;
  updatedAt: string | null;
  qarzanTypeName?: string | null;
  employeeTypeName?: string | null;
  employmentStatusName?: string | null;
  gradeName?: string | null;
  minService: number;
  maxActiveQarzan: number;
  isActive: boolean;
}

export interface QardanPolicyListPage {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  data: QardanPolicyListItem[];
  success?: boolean;
  message?: string;
}

export interface CreateQardanPolicyPayload {
  policyName: string;
  qarzanTypePublicId: string;
  employeeTypePublicId: string;
  employmentStatusPublicId: string;
  gradePublicId: string;
  minService: number,
  maxActiveQarzan: number,
  isActive: boolean;
}

interface PolicyMutationResponse {
  success?: boolean;
  message?: string;
}


export const getQarzanListTypes = async (): Promise<QarzanTypesApi[]> => {
  const res = await axiosInstance.get("/qarzan-type", {
    headers: getAuthHeader(),
  });
  return res.data;
};


// QARDAN TABLE LISTING API 
export const getQardanPolicyList = async (
  filters: QardanPolicyFilters = {},
  signal?: AbortSignal,
): Promise<QardanPolicyListPage> => {
  const response = await axiosInstance.get<{
    success?: boolean;
    message?: string;
    data: QardanPolicyListPage;
  }>("/hr/settings/qarzan-policy/search", {
    params: {
      PolicyName: filters.policyName?.trim() || undefined,
      EmployeeTypePublicId: filters.employeeTypePublicId || undefined,
      EmploymentStatusPublicId: filters.employmentStatusPublicId || undefined,
      GradePublicId: filters.gradePublicId || undefined,
      IsActive: filters.isActive ?? undefined,
      PageNumber: filters.pageNo ?? 1,
      PageSize: filters.pageSize ?? 10,
    },
    headers: getAuthHeader(),
    signal,
  });
  const result = response.data;
  if (
    result.success === false ||
    result.data?.success === false ||
    !Array.isArray(result.data?.data) ||
    !Number.isFinite(result.data.totalRecords)
  ) {
    throw new Error(result.data?.message || result.message || "Failed to load qardan policies.");
  }
  return result.data;
};

//QARDAN CREATE API 
export const createQardanPolicy = async (payload: CreateQardanPolicyPayload) => {
  const response = await axiosInstance.post<PolicyMutationResponse>(
    "/hr/settings/qarzan-policy", payload, { headers: getAuthHeader() },
  );
  if (response.data?.success === false) {
    throw new Error(response.data.message || "Failed to create qardan policy.");
  }
  return response.data;
};

// QARDAN UPDATE API
export const updateQardanPolicy = async (publicId: string, payload: CreateQardanPolicyPayload) => {
  const response = await axiosInstance.put<PolicyMutationResponse>(
    `/hr/settings/qarzan-policy/${encodeURIComponent(publicId)}`,
    payload,
    { headers: getAuthHeader() },
  );
  if (response.data?.success === false) {
    throw new Error(response.data.message || "Failed to update qardan policy.");
  }
  return response.data;
};

// OARDAN DELETE API 
export const deleteQardanPolicy = async (publicId: string) => {
  const response = await axiosInstance.delete<PolicyMutationResponse>(
    `/hr/settings/qarzan-policy/${encodeURIComponent(publicId)}`,
    { headers: getAuthHeader() },
  );
  if (response.data?.success === false) {
    throw new Error(response.data.message || "Failed to delete qardan policy.");
  }
  return response.data;
};

